import { render } from "./LinkedSortingGrid.vue?vue&type=template&id=57416dd3"
import script from "./LinkedSortingGrid.vue?vue&type=script&lang=ts"
export * from "./LinkedSortingGrid.vue?vue&type=script&lang=ts"

import "./LinkedSortingGrid.vue?vue&type=style&index=0&id=57416dd3&lang=scss"
script.render = render

export default script